const messages = {
  title: "Markedsføringssamtykker",
  required: "Påkrevd",
  answered: "✓ Besvart",
  read: "Lest",
  notRead: "Ikke lest",
  alreadyAnswered: "Allerede besvart",
  requiredQuestionsMustBeAccepted: "{count} påkravd spørsmål{plural} må godtas",
  pleaseAnswerQuestions: "Vennlegst svar på følgende spørsmål:",
  iAccept: "Jeg godtar",
  scrollToUnlock: "Rull til bunnen for å låse opp",
  fieldRequired: "Dette feltet er påkravd",
  scrollToContinue: "↓ Rull til bunnen for å fortsette",
  saving: "Lagrar...",
  saveConsents: "Lagra samtykker",
  allRequiredAccepted: "✓ Alle påkravde spørsmål godtatt",
  requiredConsentsCompleted: "{completed}/{total} påkravde samtykker fullført",
  selectConsentToView: "Velg et samtykke fra listen for å vise innholdet",
  readAllContentFirst: "Les alt innhold først: {names}",
  acceptAllRequiredIn: "Godta alle påkravde spørsmål i: {names}",
  acceptAllBeforeSaving: "Vennlegst godta alle påkravde spørsmål før du lagrer.",
  failedToSave: "Kunne ikkje lagre samtykker. Vennlegst prøv igjen.",
  errorSaving: "Det oppstod en feil ved lagring av samtykker. Vennlegst prøv igjen.",
  failedToLoad: "Kunne ikkje laste samtykker. Vennlegst oppdater siden.",
  viewPdf: "Vis PDF",
  requiredConsentTitle: "Påkravd samtykke",
  acceptAndContinue: "Godta og hald fram",
};

export default {
  messages,
};
